
import {smsApi} from '@/api';
import {userApi} from '@/api';
import {Vue, Component, Emit} from 'vue-property-decorator';
import {FormModel} from 'ant-design-vue';

@Component({
    components: {}
})
export default class Home extends Vue {
    form: any = {};
    codeDisabled: boolean = false;
    errorVerifyCode: boolean = false;
    resetSuccess: boolean = false;
    buttonName: string = '获取验证码';
    ruleFormRules: object = {
        mobilephone: [{validator: this.validatePhone, trigger: ['change', 'blur']}],
        verificationCode: [{required: true, message: '请输入验证码'}],
        password: [{validator: this.validatePassword, trigger: ['change', 'blur']}],
        repeatPassword: [{validator: this.validateRepeatPassword, trigger: ['change', 'blur']}]
    };
    issend: boolean = true;
    count: number = 60;
    timer: any = null;
    reset() {}
    validatorRules: object = {
        mobile: {
            //name与v-decorator中属性对应
            rules: [
                {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码!'} //此处配置正则表达式，手机号，可自己配置正则表达式
            ]
        }
    };
    phoneCheck(mobile: string) {
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!reg.test(mobile)) {
            return false;
        }
        return true;
    }
    validatePhone(rule: any, value: any, callback: any) {
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!reg.test(value)) return callback(new Error('请输入正确的手机号码'));
        else callback();
    }
    validatePassword(rule: any, value: any, callback: any) {
        if (!value) callback('请输入密码');
        else if (value && !/^[A-Za-z0-9_]{6,}$/.test(value)) callback('密码须设置字母、数字、下划线任意一种方式，至少6位');
        else callback();
    }
    validateRepeatPassword(rule: any, value: any, callback: any) {
        const form = this.form;
        if (!value) callback('请输入确认密码');
        else if (value && value !== form.password && value.length >= 6) callback('密码两次输入不一致');
        else callback();
    }
    sendcode() {
        const TIME_COUNT = 60;
        if (!this.timer) {
            this.count = TIME_COUNT;
            this.issend = false;
            //这里可以插入$axios调用后台接口
            this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                } else {
                    this.buttonName = '重新获取';
                    this.issend = true;
                    clearInterval(this.timer);
                    this.timer = null;
                }
            }, 1000);
        }
    }
    sendVerificationCode() {
        let me = this;
        if (!me.phoneCheck(me.form.mobilephone)) {
            this.$message.error('请输入正确的手机号码！');
            return;
        }
        if (!me.form.mobilephone || me.form.mobilephone == '') {
            this.$message.error('手机号不能为空！');
            (this.$refs.refForm as any).validateField('mobilephone');
        } else {
            smsApi.sendSms({
                context: me,
                mobile: me.form.mobilephone,
                type: 'resetPwd',
                success(data: any, parameters: any) {
                    me.sendcode();
                    me.$message.success('短信验证码发送成功！');
                }
            });
        }
    }
    submitForm() {
        let me = this;
        let form = this.$refs.refForm as FormModel;
        form.validate(valid => {
            if (valid) {
                userApi.resetUserPwd({
                    context: me,
                    data: {
                        mobile: me.form.mobilephone,
                        code: me.form.verificationCode,
                        newPwd: me.form.password
                    },
                    success(data: any, parameters: any) {
                        if (!data.data || data.data != 'success') {
                            //验证成功返回ture  失败返回false
                            me.$message.error('修改密码失败！');
                            return;
                        }
                        me.$message.success('修改密码成功！');
                        me.resetSuccess = true;
                        me.$router.push({
                            path: '/login'
                        });
                    },
                    error(data: any, message: any, parameters: any) {
                        if (message === '账号已被删除') {
                            me.$message.error('账号已被删除！');
                            return;
                        }
                        if (message === '手机号错误') {
                            me.$message.error('手机号错误！');
                            return;
                        }
                        me.errorVerifyCode = true;
                    }
                });
            } else {
                return false;
            }
        });
    }
    clearVerifyCodeError() {
        this.errorVerifyCode = false;
    }
    mounted() {}
    created() {}
}
